const setting = {
    securitySetting: '安全设置',
    resetPassword: '密码重置',
    resetPasswordDescription: '密码当前重置'
}
export default setting